import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { Toaster } from 'react-hot-toast';
import { AuthProvider } from './contexts/AuthContext';
import PrivateRoute from './components/layout/PrivateRoute';
import Navbar from './components/layout/Navbar';
import Login from './components/auth/Login';
import Register from './components/auth/Register';
import ChatInterface from './components/chat/ChatInterface';
import AdminDashboard from './components/admin/AdminDashboard';
import HomePage from './components/layout/HomePage'; // You'll need to create this component
import About from './components/pages/About';
import Profile from './components/pages/Profile';
import UtilizationExplorer from './components/experimental/UtilizationExplorer';
import Survey from './components/survey/Survey';
import ClinicianWorklist from './components/experimental/ClinicianWorklist';
function App() {
  return (
    <Router>
      <AuthProvider>
        <div className="min-h-screen bg-gray-50">
          <Toaster 
            position="top-right"
            toastOptions={{
              duration: 4000,
              style: {
                background: '#363636',
                color: '#fff',
              },
              success: {
                duration: 3000,
                iconTheme: {
                  primary: '#10b981',
                  secondary: '#fff',
                },
              },
              error: {
                duration: 4000,
                iconTheme: {
                  primary: '#ef4444',
                  secondary: '#fff',
                },
              },
            }}
          />
          
          <Routes>
            {/* Home route - public */}
            <Route path="/" element={<HomePage />} />
            
            {/* Auth routes - public */}
            <Route path="/login" element={<Login />} />
            <Route path="/register" element={<Register />} />
            <Route path="/about" element={<About />} />

            {/* Protected routes */}
            <Route
              path="/chat"
              element={
                <PrivateRoute>
                  <>
                    <Navbar />
                    <ChatInterface />
                  </>
                </PrivateRoute>
              }
            />
            
            <Route
              path="/admin"
              element={
                <PrivateRoute adminOnly>
                  <>
                    <Navbar />
                    <AdminDashboard />
                  </>
                </PrivateRoute>
              }
            />

            <Route
              path="/profile"
              element={
                <PrivateRoute>
                  <>
                    <Navbar />
                    <Profile />
                  </>
                </PrivateRoute>
              }
            />

            {/* Clinician pilot worklist */}
            <Route
              path="/experimental"
              element={
                <PrivateRoute>
                  <>
                    <Navbar />
                    <ClinicianWorklist />
                  </>
                </PrivateRoute>
              }
            />

            {/* Clinician survey */}
            <Route
              path="/survey"
              element={
                <PrivateRoute>
                  <>
                    <Navbar />
                    <Survey />
                  </>
                </PrivateRoute>
              }
            />
          </Routes>
        </div>
      </AuthProvider>
    </Router>
  );
}

export default App;
